import { Link } from "react-router-dom";
import { LegalLayout, Sec, Ul, Hi } from "@/components/legal/LegalLayout";
import { LEGAL } from "@/legal/config";

const S = [
  { id: "what", t: "What cookies and local storage are" }, { id: "use", t: "What we use and why" }, { id: "third", t: "Third-party cookies" },
  { id: "control", t: "Your choices" }, { id: "changes", t: "Changes" },
];

const ROWS = [
  ["Strictly necessary", "Sign-in session, security tokens, CSRF protection, cookie-notice choice, load balancing", "Session to 30 days", "Cannot be switched off"],
  ["Preferences", "Language, currency, theme, dismissed banners, last viewed Stage", "Up to 12 months", "Clear via browser or Account"],
  ["Analytics", "Page views, feature usage, performance timings (first-party, aggregated)", "Up to 13 months", "Opt out in Account → Privacy & data"],
  ["Marketing", "Measure campaigns from our social channels and ad networks; frequency capping", "Up to 13 months", "Only after consent; withdraw anytime"],
  ["Payments & streaming", "Fraud prevention and session handling by Paystack/Flutterwave; live-video connection state", "Session", "Set by the provider during checkout or live shows"],
];

export default function CookiePolicy() {
  return (
    <LegalLayout slug="cookie-policy" title="Cookie Policy" sections={S}
      intro="This page explains the small files and browser storage VISMARKS uses, and how you control them. It is part of our Privacy Policy.">

      <Sec id="what" n={1} t="What cookies and local storage are">
        <p>Cookies are small text files a website stores on your device; local storage is a similar browser feature. They let us keep you signed in, remember choices and understand how the Platform is used. Some are set by us (first-party) and some by partners (third-party).</p>
      </Sec>

      <Sec id="use" n={2} t="What we use and why">
        <div className="overflow-x-auto rounded-xl border border-white/10">
          <table className="w-full text-xs" data-testid="cookie-table">
            <thead className="bg-white/[0.04] text-neutral-400 uppercase tracking-wider text-[10px]">
              <tr><th className="text-left p-3">Category</th><th className="text-left p-3">Purpose</th><th className="text-left p-3">Lifetime</th><th className="text-left p-3">Control</th></tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r[0]} className="border-t border-white/5">
                  <td className="p-3 font-semibold text-white">{r[0]}</td><td className="p-3 text-neutral-300">{r[1]}</td><td className="p-3 text-neutral-400">{r[2]}</td><td className="p-3 text-neutral-400">{r[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Sec>

      <Sec id="third" n={3} t="Third-party cookies">
        <Ul items={[
          "Payment partners (Paystack, Flutterwave) set cookies during checkout for fraud prevention.",
          "Our live-video provider stores connection tokens while you watch or host a show.",
          "Embedded social content and share buttons may set cookies from those networks when you interact with them.",
          "Google (Shopping feeds, sign-in where offered) may set cookies under Google's policies.",
        ]} />
      </Sec>

      <Sec id="control" n={4} t="Your choices">
        <p>When you first visit we show a cookie notice. Strictly necessary cookies are always on. You can change analytics and marketing choices anytime in <Link className="text-[#007AFF] hover:underline" to="/account">Account → Privacy & data</Link>, and delete or block cookies in your browser settings (which may break sign-in). Where the law requires, non-essential cookies are set only after you consent. We honour Global Privacy Control signals where applicable.</p>
      </Sec>

      <Sec id="changes" n={5} t="Changes">
        <p>We update this list as features change. The version and date at the top tell you when. Questions: <Hi>{LEGAL.emails.privacy}</Hi>.</p>
      </Sec>
    </LegalLayout>
  );
}
